import { Component, computed, effect, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from 'express';
import { TrpcAPIService } from '../../trpc-api.service';
import { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import type { AppRouter } from '@server/src';
import { interval, merge, timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EditLockService } from '../edit-lock.service';
import { lockIcon, unlockIcon } from "@progress/kendo-svg-icons";

type RouterOutput = inferRouterOutputs<AppRouter>;
type EditLock = RouterOutput["editLock"]["getAndTouchLockInfo"];

@Component({
  selector: 'edit-lock',
  templateUrl: './edit-lock.component.html',
  styles: `
  .in-use {
    color: white
  }
  `
})
export class EditLockComponent {

  public lockIcon = lockIcon;
  public unlockIcon = unlockIcon;

  constructor(private route: ActivatedRoute, public auth: AuthService, public editLockService: EditLockService) {
    this.route.params.subscribe(params => {
      let klantNo = params['klantNo'];
      if (klantNo != undefined) {
        this.editLockService.klantNo.set(params['klantNo']);
        this.editLockService.lock(true);  
      } else {
        this.editLockService.klantNo.set(undefined);
      }
      
    });


  }

  public hasLock = computed(() => {
    let lockInfo = this.editLockService.lockInfo();
    if (lockInfo != undefined) {
      return lockInfo.hasLock;
    }
    return false;
  });

  public isLocked = computed(() => {
    let lockInfo = this.editLockService.lockInfo();
    if (lockInfo != undefined) {
      return lockInfo.editLock.isLocked;
    }
    return true;

  });

  public lock() {
    this.editLockService.lock(false);
  }

  public unlock() {
    this.editLockService.unlock();
  }

}
